export const REQUESTED_CATEGORIES = 'REQUESTED_CATEGORIES';
export const REQUESTED_CATEGORIES_SUCCESS = 'REQUESTED_CATEGORIES_SUCCESS';
export const REQUESTED_CATEGORIES_FAILURE = 'REQUESTED_CATEGORIES_FAILURE';
